import { MapPortalGroup } from "../IronmonMapUtils";

export const defaultPortalSize = 24;

export const portalGroups: MapPortalGroup[] = [
  {
    color: "#02cc1d",
    area: "Sprout Tower",
    portals: [
      // Entrance
      {
        portal1: {
          x: 6641,
          y: 2562,
        },
        portal2: {
          x: 6016,
          y: 2517,
        },
      },

      // Ladders
      {
        portal1: {
          x: 5938,
          y: 2350,
        },
        portal2: {
          x: 6324,
          y: 2339,
        },
      },
      {
        portal1: {
          x: 6532,
          y: 2280,
        },
        portal2: {
          x: 6162,
          y: 2276,
        },
      },
      {
        portal1: {
          x: 5873,
          y: 2361,
        },
        portal2: {
          x: 6245,
          y: 2364,
        },
      },
      {
        portal1: {
          x: 6388,
          y: 2497,
        },
        portal2: {
          x: 6899,
          y: 2498,
        },
      },
    ],
  },

  {
    color: "#3270e3",
    area: "Union Cave",
    portals: [
      // Entrance
      {
        portal1: {
          x: 6237,
          y: 5275,
        },
        portal2: {
          x: 6964,
          y: 3829,
        },
      },

      // Staircase
      {
        portal1: {
          x: 6575,
          y: 3603,
        },
        portal2: {
          x: 7039,
          y: 5024,
        },
      },

      // Exit
      {
        portal1: {
          x: 6968,
          y: 4446,
        },
        portal2: {
          x: 6319,
          y: 5595,
        },
      },
    ],
  },

  {
    color: "#e637e0",
    area: "Slowpoke Well",
    portals: [
      // Entrance
      {
        portal1: {
          x: 5805,
          y: 5544,
        },
        portal2: {
          x: 6987,
          y: 5832,
        },
      },
    ],
  },

  {
    color: "#054d25",
    area: "Ilex Forest",
    portals: [
      // Entrance
      {
        portal1: {
          x: 5148,
          y: 5613,
        },
        portal2: {
          x: 5191,
          y: 5369,
        },
      },

      // Exit
      {
        portal1: {
          x: 5142,
          y: 4586,
        },
        portal2: {
          x: 4856,
          y: 5448,
        },
      },
    ],
  },

  {
    color: "#91880a",
    area: "Department Store",
    portals: [
      // Entrance
      {
        portal1: {
          x: 4739,
          y: 4449,
        },
        portal2: {
          x: 5295,
          y: 3886,
        },
      },
    ],
  },

  {
    color: "#423e05",
    area: "Goldenrod Underground Tunnel",
    portals: [
      // Entrance
      {
        portal1: {
          x: 4449,
          y: 4520,
        },
        portal2: {
          x: 5054,
          y: 3787,
        },
      },

      // Exit
      {
        portal1: {
          x: 5054,
          y: 3391,
        },
        portal2: {
          x: 4449,
          y: 4027,
        },
      },
    ],
  },

  {
    color: "#20ba3f",
    area: "National Park",
    portals: [
      // Entrance
      {
        portal1: {
          x: 4690,
          y: 3181,
        },
        portal2: {
          x: 3378,
          y: 4738,
        },
      },

      // To Pokeathalon
      {
        portal1: {
          x: 3205,
          y: 4736,
        },
        portal2: {
          x: 4006,
          y: 5447,
        },
      },

      // Exit
      {
        portal1: {
          x: 3940,
          y: 4159,
        },
        portal2: {
          x: 4879,
          y: 2830,
        },
      },
    ],
  },

  {
    color: "#570c03",
    area: "Burned Tower",
    portals: [
      // Entrance
      {
        portal1: {
          x: 4911,
          y: 1700,
        },
        portal2: {
          x: 4645,
          y: 2277,
        },
      },

      // Ladder
      {
        portal1: {
          x: 4757,
          y: 2159,
        },
        portal2: {
          x: 4776,
          y: 2455,
        },
      },
    ],
  },

  {
    color: "#de9816",
    area: "Lighthouse",
    portals: [
      // Entrance
      {
        portal1: {
          x: 3710,
          y: 3106,
        },
        portal2: {
          x: 2763,
          y: 2870,
        },
      },
      {
        portal1: {
          x: 2917,
          y: 2907,
        },
        portal2: {
          x: 2914,
          y: 2691,
        },
      },
      {
        portal1: {
          x: 2865,
          y: 2686,
        },
        portal2: {
          x: 2864,
          y: 2455,
        },
      },
      {
        portal1: {
          x: 2964,
          y: 2465,
        },
        portal2: {
          x: 2648,
          y: 2677,
        },
      },
      {
        portal1: {
          x: 2540,
          y: 2720,
        },
        portal2: {
          x: 2831,
          y: 2819,
        },
      },
      {
        portal1: {
          x: 2801,
          y: 2684,
        },
        portal2: {
          x: 2799,
          y: 2457,
        },
      },
      {
        portal1: {
          x: 2751,
          y: 2425,
        },
        portal2: {
          x: 2767,
          y: 2197,
        },
      },
      {
        portal1: {
          x: 2864,
          y: 2249,
        },
        portal2: {
          x: 2846,
          y: 2023,
        },
      },
    ],
  },
  {
    color: "#2e1f04",
    area: "Cliff Cave",
    portals: [
      // Entrance
      {
        portal1: {
          x: 1564,
          y: 4246,
        },
        portal2: {
          x: 1453,
          y: 3784,
        },
      },
      {
        portal1: {
          x: 1094,
          y: 3990,
        },
        portal2: {
          x: 1259,
          y: 4262,
        },
      },
      {
        portal1: {
          x: 959,
          y: 4274,
        },
        portal2: {
          x: 800,
          y: 4736,
        },
      },
      {
        portal1: {
          x: 832,
          y: 4711,
        },
        portal2: {
          x: 1019,
          y: 4661,
        },
      },
      {
        portal1: {
          x: 766,
          y: 4707,
        },
        portal2: {
          x: 549,
          y: 4672,
        },
      },
      {
        portal1: {
          x: 1005,
          y: 4775,
        },
        portal2: {
          x: 975,
          y: 4443,
        },
      },
      {
        portal1: {
          x: 582,
          y: 4760,
        },
        portal2: {
          x: 956,
          y: 4193,
        },
      },
    ],
  },
  {
    color: "#fc4e03",
    area: "Bell Tower",
    portals: [
      // Entrance
      {
        portal1: {
          x: 5172,
          y: 1768,
        },
        portal2: {
          x: 2743,
          y: 1574,
        },
      },
      {
        portal1: {
          x: 3194,
          y: 1641,
        },
        portal2: {
          x: 3470,
          y: 1790,
        },
      },
      {
        portal1: {
          x: 3372,
          y: 1556,
        },
        portal2: {
          x: 3748,
          y: 1563,
        },
      },
      {
        portal1: {
          x: 3844,
          y: 1767,
        },
        portal2: {
          x: 4217,
          y: 1772,
        },
      },
      {
        portal1: {
          x: 3844,
          y: 1767,
        },
        portal2: {
          x: 4217,
          y: 1772,
        },
      },
      {
        portal1: {
          x: 4362,
          y: 1555,
        },
        portal2: {
          x: 4733,
          y: 1562,
        },
      },

      // 4F -> 5F
      {
        portal1: {
          x: 4446,
          y: 1557,
        },
        portal2: {
          x: 3323,
          y: 1208,
        },
      },
      {
        portal1: {
          x: 3322,
          y: 1418,
        },
        portal2: {
          x: 4446,
          y: 1766,
        },
      },
      {
        portal1: {
          x: 4734,
          y: 1765,
        },
        portal2: {
          x: 3612,
          y: 1417,
        },
      },

      // 5 -> 6
      {
        portal1: {
          x: 3436,
          y: 1413,
        },
        portal2: {
          x: 3801,
          y: 1417,
        },
      },

      // 6 -> 7
      {
        portal1: {
          x: 3690,
          y: 1337,
        },
        portal2: {
          x: 4069,
          y: 1342,
        },
      },

      // 7F Portals
      {
        portal1: {
          x: 4118,
          y: 1232,
        },
        portal2: {
          x: 4262,
          y: 1306,
        },
      },
      {
        portal1: {
          x: 4166,
          y: 1306,
        },
        portal2: {
          x: 3973,
          y: 922,
        },
      },
      {
        portal1: {
          x: 4214,
          y: 1428,
        },
        portal2: {
          x: 4464,
          y: 1241,
        },
      },

      // 8F Portals
      {
        portal1: {
          x: 4462,
          y: 1337,
        },
        portal2: {
          x: 3911,
          y: 823,
        },
      },
      {
        portal1: {
          x: 4526,
          y: 1314,
        },
        portal2: {
          x: 3816,
          y: 1046,
        },
      },
      {
        portal1: {
          x: 4735,
          y: 1388,
        },
        portal2: {
          x: 3752,
          y: 1022,
        },
      },
      {
        portal1: {
          x: 4719,
          y: 1302,
        },
        portal2: {
          x: 3688,
          y: 884,
        },
      },
      {
        portal1: {
          x: 4606,
          y: 1203,
        },
        portal2: {
          x: 3880,
          y: 923,
        },
      },

      // 9F Ladder
      {
        portal1: {
          x: 3781,
          y: 943,
        },
        portal2: {
          x: 4142,
          y: 947,
        },
      },
    ],
  },
  {
    color: "#f2dd1b",
    area: "Rocket Hideout",
    portals: [
      // Entrance
      {
        portal1: {
          x: 7348,
          y: 2018,
        },
        portal2: {
          x: 8296,
          y: 1089,
        },
      },
      {
        portal1: {
          x: 7602,
          y: 1407,
        },
        portal2: {
          x: 7604,
          y: 1812,
        },
      },
      {
        portal1: {
          x: 8298,
          y: 1821,
        },
        portal2: {
          x: 9063,
          y: 1813,
        },
      },
      {
        portal1: {
          x: 9062,
          y: 1501,
        },
        portal2: {
          x: 8299,
          y: 1512,
        },
      },
      {
        portal1: {
          x: 7602,
          y: 1514,
        },
        portal2: {
          x: 8372,
          y: 1504,
        },
      },
      {
        portal1: {
          x: 8372,
          y: 1574,
        },
        portal2: {
          x: 7602,
          y: 1589,
        },
      },
    ],
  },
  {
    color: "#020445",
    area: "Dark Cave",
    portals: [
      // Entrance
      {
        portal1: {
          x: 7877,
          y: 3209,
        },
        portal2: {
          x: 8150,
          y: 3437,
        },
      },
      {
        portal1: {
          x: 8484,
          y: 3162,
        },
        portal2: {
          x: 8166,
          y: 3024,
        },
      },
      {
        portal1: {
          x: 9028,
          y: 2346,
        },
        portal2: {
          x: 9236,
          y: 2292,
        },
      },
      {
        portal1: {
          x: 8954,
          y: 3844,
        },
        portal2: {
          x: 8884,
          y: 3954,
        },
      },
    ],
  },
  {
    color: "#04bbc4",
    area: "Ice Path",
    portals: [
      // Entrance
      {
        portal1: {
          x: 9030,
          y: 1925,
        },
        portal2: {
          x: 8454,
          y: 1404,
        },
      },
      {
        portal1: {
          x: 9156,
          y: 775,
        },
        portal2: {
          x: 9356,
          y: 846,
        },
      },
      {
        portal1: {
          x: 9660,
          y: 691,
        },
        portal2: {
          x: 8655,
          y: 464,
        },
      },
      {
        portal1: {
          x: 8495,
          y: 540,
        },
        portal2: {
          x: 9340,
          y: 1366,
        },
      },
      {
        portal1: {
          x: 9645,
          y: 1380,
        },
        portal2: {
          x: 9039,
          y: 392,
        },
      },
      {
        portal1: {
          x: 8927,
          y: 600,
        },
        portal2: {
          x: 9692,
          y: 1084,
        },
      },
      {
        portal1: {
          x: 9356,
          y: 1108,
        },
        portal2: {
          x: 9155,
          y: 936,
        },
      },
      {
        portal1: {
          x: 9157,
          y: 1182,
        },
        portal2: {
          x: 9988,
          y: 1637,
        },
      },

      // Holes
      {
        portal1: {
          x: 9437,
          y: 718,
        },
        portal2: {
          x: 8433,
          y: 494,
        },
      },
      {
        portal1: {
          x: 9421,
          y: 815,
        },
        portal2: {
          x: 8416,
          y: 591,
        },
      },
      {
        portal1: {
          x: 9564,
          y: 827,
        },
        portal2: {
          x: 8561,
          y: 604,
        },
      },
      {
        portal1: {
          x: 9548,
          y: 682,
        },
        portal2: {
          x: 8544,
          y: 456,
        },
      },
    ],
  },
  {
    color: "#0d0b33",
    area: "Dragon's Den",
    portals: [
      // Entrance
      {
        portal1: {
          x: 9590,
          y: 1488,
        },
        portal2: {
          x: 10224,
          y: 775,
        },
      },
    ],
  },
  {
    color: "#13b091",
    area: "Whirl Islands",
    portals: [
      // NW Island
      {
        portal1: {
          x: 2223,
          y: 4128,
        },
        portal2: {
          x: 1870,
          y: 4916,
        },
      },
      // NE Island
      {
        portal1: {
          x: 2689,
          y: 4116,
        },
        portal2: {
          x: 2466,
          y: 4906,
        },
      },
      // SW Island
      {
        portal1: {
          x: 2270,
          y: 4486,
        },
        portal2: {
          x: 1812,
          y: 5806,
        },
      },
      // SE Island
      {
        portal1: {
          x: 2752,
          y: 4510,
        },
        portal2: {
          x: 2954,
          y: 5774,
        },
      },
      {
        portal1: {
          x: 1818,
          y: 4868,
        },
        portal2: {
          x: 1919,
          y: 5065,
        },
      },
      {
        portal1: {
          x: 2690,
          y: 4860,
        },
        portal2: {
          x: 2576,
          y: 5136,
        },
      },
      {
        portal1: {
          x: 2770,
          y: 4712,
        },
        portal2: {
          x: 2721,
          y: 5030,
        },
      },
      {
        portal1: {
          x: 1785,
          y: 5748,
        },
        portal2: {
          x: 2018,
          y: 5606,
        },
      },
      {
        portal1: {
          x: 2120,
          y: 5751,
        },
        portal2: {
          x: 2289,
          y: 5606,
        },
      },
      {
        portal1: {
          x: 2956,
          y: 5647,
        },
        portal2: {
          x: 2607,
          y: 5559,
        },
      },
      {
        portal1: {
          x: 2049,
          y: 5538,
        },
        portal2: {
          x: 2985,
          y: 5078,
        },
      },
      {
        portal1: {
          x: 3064,
          y: 4906,
        },
        portal2: {
          x: 2415,
          y: 5464,
        },
      },
    ],
  },
  {
    color: "#ebc802",
    area: "Radio Tower",
    portals: [
      // Entrance
      {
        portal1: {
          x: 4370,
          y: 4214,
        },
        portal2: {
          x: 4146,
          y: 3487,
        },
      },
      {
        portal1: {
          x: 4502,
          y: 3363,
        },
        portal2: {
          x: 4497,
          y: 3192,
        },
      },
      {
        portal1: {
          x: 4135,
          y: 3189,
        },
        portal2: {
          x: 4133,
          y: 3019,
        },
      },
      {
        portal1: {
          x: 4326,
          y: 3016,
        },
        portal2: {
          x: 4320,
          y: 2840,
        },
      },
      {
        portal1: {
          x: 4392,
          y: 3016,
        },
        portal2: {
          x: 4388,
          y: 2840,
        },
      },
      {
        portal1: {
          x: 4140,
          y: 2836,
        },
        portal2: {
          x: 4171,
          y: 2663,
        },
      },
      {
        portal1: {
          x: 4501,
          y: 2836,
        },
        portal2: {
          x: 4470,
          y: 2663,
        },
      },
      {
        portal1: {
          x: 4356,
          y: 2624,
        },
        portal2: {
          x: 4331,
          y: 2502,
        },
      },

      // To Basement
      {
        portal1: {
          x: 5414,
          y: 3721,
        },
        portal2: {
          x: 4010,
          y: 3592,
        },
      },
      {
        portal1: {
          x: 3972,
          y: 3720,
        },
        portal2: {
          x: 4088,
          y: 3731,
        },
      },
      {
        portal1: {
          x: 4506,
          y: 3545,
        },
        portal2: {
          x: 5385,
          y: 3851,
        },
      },
    ],
  },
  {
    color: "#024212",
    area: "Victory Road",
    portals: [
      // Tojo Falls
      {
        portal1: {
          x: 10676,
          y: 4792,
        },
        portal2: {
          x: 10787,
          y: 4662,
        },
      },
      {
        portal1: {
          x: 11024,
          y: 4634,
        },
        portal2: {
          x: 10915,
          y: 4767,
        },
      },

      // Entrance
      {
        portal1: {
          x: 13415,
          y: 3096,
        },
        portal2: {
          x: 13055,
          y: 4550,
        },
      },
      {
        portal1: {
          x: 12623,
          y: 3908,
        },
        portal2: {
          x: 12244,
          y: 3602,
        },
      },
      {
        portal1: {
          x: 12948,
          y: 3670,
        },
        portal2: {
          x: 12939,
          y: 3177,
        },
      },
      {
        portal1: {
          x: 13018,
          y: 2967,
        },
        portal2: {
          x: 13027,
          y: 3461,
        },
      },
      {
        portal1: {
          x: 12553,
          y: 3252,
        },
        portal2: {
          x: 12563,
          y: 3752,
        },
      },
      {
        portal1: {
          x: 12232,
          y: 2929,
        },
        portal2: {
          x: 12244,
          y: 3409,
        },
      },

      // Holes
      {
        portal1: {
          x: 12473,
          y: 2916,
        },
        portal2: {
          x: 12484,
          y: 3401,
        },
      },
      {
        portal1: {
          x: 12569,
          y: 3153,
        },
        portal2: {
          x: 12581,
          y: 3671,
        },
      },
      {
        portal1: {
          x: 12627,
          y: 3745,
        },
        portal2: {
          x: 12618,
          y: 3228,
        },
      },
      {
        portal1: {
          x: 13049,
          y: 3039,
        },
        portal2: {
          x: 13058,
          y: 3547,
        },
      },
      {
        portal1: {
          x: 13044,
          y: 3730,
        },
        portal2: {
          x: 13033,
          y: 3213,
        },
      },

      // Exit
      {
        portal1: {
          x: 12762,
          y: 2850,
        },
        portal2: {
          x: 13422,
          y: 2910,
        },
      },
    ],
  },
  {
    color: "#2e2c2d",
    area: "Mt. Mortar",
    portals: [
      // Left Entrance
      {
        portal1: {
          x: 5873,
          y: 1990,
        },
        portal2: {
          x: 6034,
          y: 1766,
        },
      },
      // Middle Entrance
      {
        portal1: {
          x: 6318,
          y: 2045,
        },
        portal2: {
          x: 6435,
          y: 1815,
        },
      },
      // Right Entrance
      {
        portal1: {
          x: 6783,
          y: 1981,
        },
        portal2: {
          x: 6830,
          y: 1769,
        },
      },
      // Top Middle
      {
        portal1: {
          x: 6352,
          y: 1872,
        },
        portal2: {
          x: 6660,
          y: 1822,
        },
      },

      // Entrance
      {
        portal1: {
          x: 6256,
          y: 1566,
        },
        portal2: {
          x: 5774,
          y: 1040,
        },
      },
      {
        portal1: {
          x: 6436,
          y: 1118,
        },
        portal2: {
          x: 5421,
          y: 1668,
        },
      },
      {
        portal1: {
          x: 6608,
          y: 1564,
        },
        portal2: {
          x: 6127,
          y: 1041,
        },
      },
      {
        portal1: {
          x: 7009,
          y: 1525,
        },
        portal2: {
          x: 6529,
          y: 993,
        },
      },
      {
        portal1: {
          x: 6130,
          y: 1262,
        },
        portal2: {
          x: 5650,
          y: 756,
        },
      },
      {
        portal1: {
          x: 6815,
          y: 1268,
        },
        portal2: {
          x: 6338,
          y: 767,
        },
      },
      {
        portal1: {
          x: 6436,
          y: 1735,
        },
        portal2: {
          x: 5000,
          y: 954,
        },
      },

      // Upper Cave
      {
        portal1: {
          x: 5135,
          y: 1186,
        },
        portal2: {
          x: 5666,
          y: 135,
        },
      },

      // Basement
      {
        portal1: {
          x: 4825,
          y: 204,
        },
        portal2: {
          x: 5777,
          y: 457,
        },
      },
    ],
  },
  {
    color: "#ac21c4",
    area: "Violet Gym",
    portals: [
      // Entrance
      {
        portal1: {
          x: 6512,
          y: 3031,
        },
        portal2: {
          x: 7100,
          y: 3036,
        },
      },
    ],
  },
  {
    color: "#66d11f",
    area: "Azalea Gym",
    portals: [
      // Entrance
      {
        portal1: {
          x: 5357,
          y: 5720,
        },
        portal2: {
          x: 4365,
          y: 5853,
        },
      },
    ],
  },
  {
    color: "#bf17ae",
    area: "Goldenrod Gym",
    portals: [
      // Entrance
      {
        portal1: {
          x: 4755,
          y: 4029,
        },
        portal2: {
          x: 5126,
          y: 4470,
        },
      },
    ],
  },
  {
    color: "#4a4635",
    area: "Ecruteak Gym",
    portals: [
      // Entrance
      {
        portal1: {
          x: 4915,
          y: 2141,
        },
        portal2: {
          x: 5692,
          y: 2804,
        },
      },
    ],
  },
  {
    color: "#559ec2",
    area: "Cianwood Gym",
    portals: [
      // Entrance
      {
        portal1: {
          x: 1596,
          y: 4375,
        },
        portal2: {
          x: 1540,
          y: 4954,
        },
      },
    ],
  },
  {
    color: "#4a5257",
    area: "Olivine Gym",
    portals: [
      // Entrance
      {
        portal1: {
          x: 3201,
          y: 2836,
        },
        portal2: {
          x: 3597,
          y: 2714,
        },
      },
    ],
  },
  {
    color: "#4a1b1f",
    area: "Mahogany Gym",
    portals: [
      // Entrance
      {
        portal1: {
          x: 7267,
          y: 2128,
        },
        portal2: {
          x: 7397,
          y: 2963,
        },
      },
    ],
  },
  {
    color: "#1a1616",
    area: "Blackthorn Gym",
    portals: [
      // Entrance
      {
        portal1: {
          x: 9526,
          y: 1720,
        },
        portal2: {
          x: 10262,
          y: 2561,
        },
      },
    ],
  },
];
